<template>
  <a-spin :spinning="formOption.busy">
    <a-form
        ref="form"
        :form="form"
        :label-col="{ span: 12 }"
        :wrapper-col="{ span: 12 }"
    >
      <a-row :gutter="24">
        <a-col :span="16">
          <a-form-item label="文件名称"
                       :label-col="{ span: 6 }"
                       :wrapper-col="{ span: 16 }">
            <a-input v-decorator="['infoName',rules.infoName]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col>
          <div style="color: #ff0000;line-height: 30px;padding-left: 11%;">
            文件类型:（仅可选择一类文件类型，若切换则已填写内容会被清空）
          </div>
          <a-form-item label="文件类型"
                       :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 20 }">
            <a-radio-group button-style="solid" v-model="infoClassify" @change="toggleType(infoClassify)">
              <a-radio-button value="image">图片</a-radio-button>
              <a-radio-button value="video">视频</a-radio-button>
              <a-radio-button value="file">文件</a-radio-button>
            </a-radio-group>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col>
          <template v-if="infoClassify === 'image'">
            <a-form-item label="图片设置"
                         :label-col="{ span: 4 }"
                         :wrapper-col="{ span: 20 }">
              <uploader :num="9" v-decorator="['infoUrl', rules.infoUrl]" :accept="'.jpg,.jpeg,.PNG,.JPG,.JPEG'"
                        :url="api.temp.UPLOAD_TALK"></uploader>
            </a-form-item>
            <span style="color: #f00;margin-left: 16.66666666666666666%">建议格式：.png,.jpg, 最大为10MB,最多不超过9张</span>
          </template>
          <template v-if="infoClassify === 'video'">
            <a-form-item label="视频封面"
                         :label-col="{ span: 4 }"
                         :wrapper-col="{ span: 20 }"
                         style="margin-top: 10px"
            >
              <uploader ref="videoCoverUploader" :num="1" v-decorator="['coverImg']" :accept="'image/*'"
                        :url="api.temp.UPLOAD_LIMIT"></uploader>
            </a-form-item>
            <a-form-item label="视频设置"
                         :label-col="{ span: 4 }"
                         :wrapper-col="{ span: 20 }">
              <uploader ref="videoUploader" :num="1" v-decorator="['infoUrl', rules.infoUrl]" :accept="'.mp4'"
                        :url="api.temp.UPLOAD_TALK"></uploader>
            </a-form-item>
            <span style="color: #f00;margin-left: 16.66666666666666666%">建议格式：.mp4，最大为10MB，最多1个</span>
          </template>
          <template v-if="infoClassify === 'file'">
            <a-form-item label="文件封面"
                         :label-col="{ span: 4 }"
                         :wrapper-col="{ span: 20 }"
                         style="margin-top: 10px"
            >
              <uploader :num="1" v-decorator="['coverImg']" :accept="'image/*'"
                        :url="api.temp.UPLOAD_LIMIT"></uploader>
            </a-form-item>
            <a-form-item label="文件"
                         :label-col="{ span: 4 }"
                         :wrapper-col="{ span: 20 }">
              <uploader :num="1" v-decorator="['infoUrl', rules.infoUrl]"
                        :accept="'.xlsx,.ppt,.doc,.pdf,.txt,.xls,.docx,.pptx'"
                        :url="api.temp.UPLOAD_TALK"></uploader>
            </a-form-item>
            <span style="color: #f00;margin-left: 16.66666666666666666%">建议格式.xlsx,.ppt,.doc,.pdf,.txt,.xls,.docx,.pptx文件，最大为20MB，最多1个</span>
          </template>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="8">
          <a-form-item label="文件分组">
            <a-tree-select
                v-decorator="['infoTypeId',rules.infoTypeId]"
                allow-clear
                :dropdown-style="{ maxHeight: '300px', overflow: 'auto' }"
                :treeData="treeData"
                :replaceFields="{children:'children', title:'infoTypeName', key:'infoTypeId', value: 'infoTypeId' }"
            >
            </a-tree-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="16">
          <a-form-item label="关键词" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
            <a-select
                v-decorator="['keyWords']"
                mode="multiple"
                :options="tagOptions">
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-button type="link" @click="addTag">新增</a-button>
          <a-button type="link" @click="refreshTag">刷新</a-button>
        </a-col>
      </a-row>
    </a-form>

    <a-space class="a-form-btn-box">
      <a-button @click="endEdit('cancelled')">取消</a-button>
      <a-button type="primary" @click="_save(false)">保存</a-button>
    </a-space>
    <a-modal
        title="新增关键词"
        :closable="true"
        :footer="null"
        :maskClosable="false"
        :visible="editModalVisible"
        @cancel="closeEdit"
        :width="600"
    >
      <detailForm
                  v-if="editModalVisible"
                  ref="detailForm"
                  @cancelled="closeEdit()"
                  @saved="closeEdit(true)">
      </detailForm>
    </a-modal>
  </a-spin>
</template>

<script>
import {formMixin} from "@/utils/FormMixin";
import {formatter as fmt} from "@/utils/form-formatter";
//通用代码api
import {loadBaseCodeData} from '@/services/baseCodeSource';

console.log(loadBaseCodeData)

//接口API
import {dataApi} from '@/services/question/external';
import detailForm from './detail/keyWords';

import {mapState} from "vuex";
import XEUtils from "xe-utils";

/**
 * 加载规则
 */
function getRulesTemplate() {
  return {
    infoUrl: {
      rules: [{required: true, message: "请上传文件"}],
    },
    infoName: {
      rules: [{required: true, message: "请输入名称"}],
    },
    infoTypeId: {
      rules: [{required: true, message: "请选择分组"}],
    }
  };
}


/**
 * 加载数据之后执行的函数(新建表单也会执行)
 */
function afterLoad() {
  //给子表赋值

}

/**
 * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
 * 一般是用来写表单默认值 或者写不在表单中需要保存的值
 * @returns {Object}
 */
function newEntity() {
  return {
    infoTypeId: this.infoTypeId
  }
}

/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {
  let entity = await dataApi.getFormDetail(rowId);
  this.infoClassify = entity.data.infoClassify
  entity.data.keyWords = entity.data.keyWordsList
  return fmt.formatFormLoad(entity);
}


/**
 * 加载基础数据
 */
async function loadBaseData() {
  let menuData = await dataApi.getQuestionTree();
  // 新增分类禁用 仅最后一级可选
  menuData.data.forEach(item=>{
    item.disabled = true
  })

  let treeData = XEUtils.toArrayTree(menuData.data, {
    key: 'infoTypeId',
    parentKey: 'parentId',
    children: 'children'
  });
  // 新增分类禁用 仅最后一级可选
  treeData.forEach(item=>{
    if(item.children.length){
      item.children.forEach(e=>{
        if(e.children.length){
          e.children.forEach(x=>{
            x.disabled = false
          })
        }
      })
    }
  })

  this.treeData = treeData;
  let keyData = await dataApi.getKeyWords();

  this.tagOptions = keyData.data.map(item => {
    return {
      title: item.keyWordsName,
      key: item.keyWordsId
    }
  })
}

/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function save(entities, vm) {
  //其他数据处理 类似子表放在这里
  console.log(entities)
  if (entities.keyWords !== '') {
    entities.keyWordsList = entities.keyWords.split(',')
  }
  entities.infoClassify = vm.infoClassify
  entities.infoId = vm.keyId || 0
  await dataApi.saveFormDetail(entities);
}


/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  components: {
    detailForm
  },
  props: ['infoTypeId'],
  computed: {
    ...mapState('account', {currUser: 'user'}),
  },
  data() {
    return {
      treeData: [],
      tagOptions: [],
      editModalVisible: false,
      infoClassify: 'image'
    }
  },
  methods: {
    loadEntity,
    newEntity,
    save,
    getRulesTemplate,
    loadBaseData,
    afterLoad,
    async refreshTag() {
      let keyData = await dataApi.getKeyWords();

      this.tagOptions = keyData.data.map(item => {
        return {
          title: item.keyWordsName,
          key: item.keyWordsId
        }
      })

      this.$message.success('关键词刷新成功')
    },
    addTag() {
      this.editModalVisible = true
    },
    closeEdit() {
      this.editModalVisible = false
    },
    /**
     * 切换选项卡清空 文件、视频、图片及封面
     */
    toggleType(value){
      this.infoClassify = ''
      this.$nextTick(() => {
        this.infoClassify = value
      })
    }
  },
};
</script>

<style scoped lang="less">
</style>
